import { NotificationHistory } from "@modules/roadLoad/model";

import { INotificationIntegration } from "../Notifications";
import { ROADLOAD, PORTAL } from "../model/interface";
import { IUserNotificationWithDetails } from "@modules/notifications/model/INotifications";

const useNotification = () => {
  const unifieldNotification = (
    roadLoadNotificationHistoryPortal: NotificationHistory | null,
    notificationsPortal: IUserNotificationWithDetails[]
  ): INotificationIntegration[] => {
    const unifieldListRoadLoad =
      roadLoadNotificationHistoryPortal?.rows?.map((item) => {
        return {
          id: item.id,
          title: item.title,
          message: item.message,
          read: item.read,

          sentAt: item.sentAt ?? "",
          subsidiaryRef: item.subsidiaryRef,
          type: ROADLOAD,
        };
      }) ?? [];

    const unifieldList = notificationsPortal.map((item) => {
      return {
        id: `${item.id}`,
        title: item.notification.title,
        message: item.notification.content,
        read: Boolean(item.readAt),

        sentAt: item.createdAt ?? "",
        subsidiaryRef: item.notification.centers
          ? item.notification.centers.join(",")
          : "",
        type: PORTAL,
      };
    });

    return [...unifieldList, ...unifieldListRoadLoad];
  };

  return {
    state: {},
    action: {
      unifieldNotification,
    },
  };
};

export default useNotification;
